query GetNotificationMessageCount {
  userNotificationUnreadCounts
  userMessageUnreadCounts
  userPendingApprovalCount
}